import moment from 'moment-timezone'

/** 判定に使う切替日時。DB（tw_ntt_aaa_switchovers）から読み込んだ値を保持する */
let switchoverAt: string | null = null

/**
 * 判定に使う切替日時を設定する。
 */
export function setNttAaaSwitchoverAt(value: string | Date): void {
  if (!value) {
    throw new Error('tw_ntt_aaa_switchovers.switchover_datetime 値は必須です.')
  }

  const parsed = moment(value)

  if (!parsed.isValid()) {
    throw new Error(`tw_ntt_aaa_switchovers.switchover_datetime 値が日時として不正です: ${String(value)}`)
  }

  switchoverAt = parsed.toISOString()
}

/** 設定済みの切替日時を返す */
export function getNttAaaSwitchoverAt(): string {
  if (switchoverAt === null) {
    throw new Error('NTT AAA 切替日時が未設定です')
  }

  return switchoverAt
}

/**
 * 現在時刻が NTT AAA の切替日時より前かを判定する。
 * 切替日時ちょうどは切替前に含まない。
 */
export function isBeforeNttAaaSwitchover(): boolean {
  return moment().isBefore(getNttAaaSwitchoverAt())
}

/**
 * 現在時刻が NTT AAA の切替日時以降かを判定する。
 * 切替日時ちょうどを切替後に含む。
 */
export function isAtOrAfterNttAaaSwitchover(): boolean {
  return !isBeforeNttAaaSwitchover()
}

/**
 * 指定した期間の終了日時が NTT AAA の切替日時より後かを判定する。
 * 終了日時は「未満」の指定であるため、切替日時ちょうどは切替前として扱う。
 */
export function isPeriodEndAfterNttAaaSwitchover(endDatetime: string | Date): boolean {
  return moment(endDatetime).isAfter(getNttAaaSwitchoverAt())
}

/**
 * 指定した期間の開始日時が NTT AAA の切替日時より前かを判定する。
 */
export function isPeriodStartBeforeNttAaaSwitchover(startDatetime: string | Date): boolean {
  return moment(startDatetime).isBefore(getNttAaaSwitchoverAt())
}
